(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-navigation]').forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const nav = header.querySelector('.header__nav');
      const disclosures = [...header.querySelectorAll('[data-nav-disclosure]')];
      const shade = header.querySelector('[data-nav-overlay]');
      const mobile = header.querySelector('#MobileMenu');
      const mobileButton = header.querySelector('[data-menu-open]');
      const desktop = window.matchMedia('(min-width: 1101px)');
      const controller = new AbortController();
      const { signal } = controller;
      const position = () => header.style.setProperty('--navigation-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      const sync = () => {
        const open = disclosures.some(details => details.open);
        if (shade) shade.hidden = !open;
        disclosures.forEach(details => details.querySelector('[data-nav-trigger]').setAttribute('aria-expanded', String(details.open)));
        position();
      };
      const close = (except = null, returnFocus = false) => {
        disclosures.forEach(details => {
          if (details === except || !details.open) return;
          details.open = false;
          if (returnFocus) details.querySelector('[data-nav-trigger]').focus();
        });
        sync();
      };
      disclosures.forEach(details => {
        const trigger = details.querySelector('[data-nav-trigger]');
        details.addEventListener('toggle', () => {
          if (details.open) close(details);
          sync();
        }, { signal });
        trigger.addEventListener('click', () => close(details), { signal });
        trigger.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          close(details);
          details.open = true;
          const links = [...details.querySelectorAll('[data-nav-panel] a[href]')];
          (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
          sync();
        }, { signal });
      });
      nav?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (!disclosures.some(details => details.open)) return;
          event.preventDefault();
          close(null, true);
        }
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        if (!event.target.matches('[data-nav-trigger], .header__nav-link')) return;
        const triggers = [...nav.querySelectorAll('[data-nav-trigger], .header__nav-link')];
        const direction = getComputedStyle(header).direction === 'rtl' ? -1 : 1;
        const delta = (event.key === 'ArrowRight' ? 1 : -1) * direction;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? triggers.length - 1 : (triggers.indexOf(event.target) + delta + triggers.length) % triggers.length;
        event.preventDefault();
        close();
        triggers[index]?.focus();
      }, { signal });
      document.addEventListener('click', event => {
        if (!nav?.contains(event.target)) close();
      }, { signal });
      document.addEventListener('focusin', event => {
        if (!nav?.contains(event.target)) close();
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && disclosures.some(details => details.open)) {
          event.preventDefault();
          close(null, true);
        }
      }, { signal });
      mobileButton?.addEventListener('click', () => close(), { signal });
      mobile?.querySelectorAll('[data-mobile-accordion]').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          mobile.querySelectorAll('[data-mobile-accordion]').forEach(other => {
            if (other !== details) other.open = false;
          });
        }, { signal });
      });
      const resize = () => {
        const focusedPanel = document.activeElement?.closest('[data-nav-panel]');
        close();
        if (!desktop.matches && focusedPanel && header.contains(focusedPanel)) mobileButton?.focus();
        if (desktop.matches && mobile && !mobile.hidden) {
          mobile.querySelector('[data-menu-close]')?.click();
          header.querySelector('.header__logo')?.focus();
        }
      };
      desktop.addEventListener('change', resize, { signal });
      window.addEventListener('resize', position, { passive: true, signal });
      window.addEventListener('scroll', position, { passive: true, signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header)) {
          close();
          controller.abort();
          delete header.dataset.navigationReady;
        }
      }, { signal });
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
